import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomSelectVerify from "../../unit/forms/CustomSelectVerify";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomNumberTextField from "../../unit/forms/CustomNumberTextField";
import useNotify from "../../unit/useNotify";
import { useRefresh } from "react-admin";
import PaperComponent from "../../unit/PaperComponent";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
export default function CustomLoanUpdateChargedOffStatusDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const [open, setOpen] = React.useState(false);
  const [changeLoanStatus, setChangeLoanStatus] = React.useState("Active");
  const [recoveryAmount, setRecoveryAmount] = React.useState(0);
  const [recoveryAmountError, setRecoveryAmountError] = React.useState(false);
  const [netChargeOffAmount, setNetChargeOffAmount] = React.useState(0);
  const refresh = useRefresh();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <div>
      <Button
        label="Reactivate"
        variant="contained"
        size="medium"
        color="primary"
        sx={{ marginLeft: "10px", width: "175px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="loan-update-switch-status-dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.loannum = recordProp?.loan?.loanNum;
            console.log("update loan status formJson =====>", formJson);

            const reqUrl = `loans/actions/updateChargedOffStatus`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            // console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              props.onReactivateSuccess?.();
              handleClose();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle title={`Charge-Off Loan`} subTitle="Reactivate" />
        </DialogTitle>
        <DialogContent>
          <Box sx={{ height: "200px", minHeight: "200px" }}>
            <DialogContentText>
              <Typography variant="body1" sx={{ color: "red" }}>
                Move this loan to Active status. This operation cannot be
                reversed. Please check all the inputs before clicking Confirm to
                proceed.
              </Typography>
            </DialogContentText>
            <Grid container sx={{ mt: 2, mb: 2, pb: 2 }}>
              {/* <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Charge-Off Amount" />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelectVerify
                    fullWidth
                    id="loan_status"
                    name="loan_status"
                    variant="outlined"
                    optionlist={[
                      { value: "Active", label: "Active Loan" },
                      // { value: "Charged-Off", label: "Charged-Off Loan" },
                      // { value: "Paid-Off", label: "Paid-Off Loan" },
                      // { value: "Voided", label: "Voided Loan" },
                    ]}
                    defaultValue="Active"
                    value={changeLoanStatus}
                    onChange={(e) => {
                      setChangeLoanStatus(e.target.value);
                    }}
                    required={true}
                    helperText="no"
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid> */}
              {/* 
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Updated Date" />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    id="update_date"
                    name="update_date"
                    sx={{
                      "& .MuiInputBase-input": {
                        backgroundColor: "#eee",
                      },
                    }}
                    disabled={true}
                    defaultValue={new Date()}
                    required={true}
                    helperText="no"
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid> */}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Confirm" />
        </DialogActions>
      </Dialog>
    </div>
  );
}
